import { render } from "./MatrizLegal.vue?vue&type=template&id=28e04138&scoped=true"
import script from "./MatrizLegal.vue?vue&type=script&lang=js"
export * from "./MatrizLegal.vue?vue&type=script&lang=js"

import "./MatrizLegal.vue?vue&type=style&index=0&id=28e04138&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e04138"]])

export default __exports__